export default "__VITE_ASSET__Bp45I8QF__"